import { render, staticRenderFns } from "./PerfilAluno.vue?vue&type=template&id=55028718&scoped=true&"
import script from "./PerfilAluno.vue?vue&type=script&lang=js&"
export * from "./PerfilAluno.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAluno.vue?vue&type=style&index=0&id=55028718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55028718",
  null
  
)

export default component.exports